/**
 * Promotional Carousel Component
 * Displays promotional banners in a carousel with auto-slide
 * Shows 2 images per slide, auto-slides in a loop
 */

import React, { useState, useEffect, useRef } from 'react';
import styles from './PromoCarousel.module.css';

const PromoCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);
  const intervalRef = useRef(null);

  // Promotional banners data - using local images
  const banners = [
    {
      id: 1,
      image: '/assets/images/first.webp',
      title: 'Get a free bet with no wagering',
      subtitle: 'Bonus requirement: 3 bets of INR 150 + at odds of 1.5+',
      amount: '150.00',
      showAmount: true,
      showButton: false,
    },
    {
      id: 2,
      image: '/assets/images/second.webp',
      title: 'Get free bets',
      subtitle: 'for bets on any sports event',
      showAmount: false,
      showButton: true,
      buttonText: 'More details',
    },
    {
      id: 3,
      image: '/assets/images/third.webp',
      title: 'x6 for Jackopot Coins',
      subtitle: 'Place sports bets and earn even more Jackopot Coins',
      showAmount: false,
      showButton: false,
    },
 
  ];

  // Calculate how many slides we need (2 images per slide)
  const itemsPerSlide = 2;
  const totalSlides = Math.ceil(banners.length / itemsPerSlide);

  // Auto-slide functionality
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, 5000); // Change slide every 5 seconds

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [totalSlides]);


  // Get banners for current slide
  const getCurrentSlideBanners = () => {
    const start = currentIndex * itemsPerSlide;
    return banners.slice(start, start + itemsPerSlide);
  };

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carousel} ref={carouselRef}>
        <div className={styles.carouselTrack}>
          {getCurrentSlideBanners().map((banner) => (
            <div key={banner.id} className={styles.bannerCard}>
              <img 
                src={banner.image} 
                alt={banner.title}
                className={styles.bannerImage}
              />
              {/* <div className={styles.bannerOverlay}></div>
              <div className={styles.bannerContent}>
                <div className={styles.bannerText}>
                  <div className={styles.bannerTitle}>{banner.title}</div>
                  <div className={styles.bannerSubtitle}>{banner.subtitle}</div>
                  {banner.showAmount && (
                    <div className={styles.bannerAmount}>
                      <span className={styles.amountValue}>{banner.amount}</span>
                      <span className={styles.amountIcon}>🎁</span>
                    </div>
                  )}
                </div>
                {banner.showButton && (
                  <button className={styles.bannerButton} type="button">
                    {banner.buttonText}
                  </button>
                )}
              </div> */}
            
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromoCarousel;
